import request from '@/utils/request'

/**
 * 报表中心-日巡查清单异常情况(导出Excel)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function canteenRourceReportExportNocheckstatisticsGet(data) {
  return request({
    type: 'device',
    url: 'canteenRource/report/export/nocheckstatistics/get',
    method: 'post',
    data
  })
}

/**
 * 报表中心-日巡查清单异常情况(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function canteenRourceReportNocheckstatisticsGet(data) {
  return request({
    type: 'device',
    url: 'canteenRource/report/nocheckstatistics/get',
    method: 'post',
    data
  })
}

/**
 * 根据组织ID和年份获取食堂资源统计信息(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function canteenRourceYearandorgGet(data) {
  return request({
    type: 'device',
    url: 'canteenRource/yearAndOrg/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/CanteenResource.js